import { useEffect, useState } from "react";

import api from "../../../api/api";
import TaskSortedCases from "../modals/TaskSortedCase";
import "./openCase.css";
const OpenCases = () => {
  const origin = process.env.REACT_APP_BACKEND_URL;
  const [openCases, setOpenCases] = useState([]);
  const fetchOpenCases = async () => {
    try {
      const response = await api.get(`${origin}/api/homepage/casetype-percentage/`);

      if (response.status === 200) {
        const data = response.data;

        setOpenCases(data);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  useEffect(() => {
    fetchOpenCases();
  }, []);

  const adjustCaseDetailsWidths = () => {
    const leftColumns = document.querySelectorAll(".case-type-width");

    const rightColumns = document.querySelectorAll(".count-width-home");

    let maxLeftWidth = 0;
    let maxRightWidth = 0;

    // Calculate maximum width for left and right columns
    leftColumns.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxLeftWidth = Math.max(maxLeftWidth, width);
    });

    leftColumns.forEach((column) => {
      column.style.width = `${maxLeftWidth}px`;
    });

    rightColumns.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxRightWidth = Math.max(maxRightWidth, width);
    });

    rightColumns.forEach((column) => {
      column.style.width = `${maxRightWidth}px`;
      column.style.maxWidth = `${maxRightWidth}px`;
    });
  };

  useEffect(() => {
    adjustCaseDetailsWidths();
    window.addEventListener("resize", adjustCaseDetailsWidths);
    return () => {
      window.removeEventListener("resize", adjustCaseDetailsWidths);
    };
  }, [openCases]);
  const [modalData, setModalData] = useState({
    show: false,
    caseTypeId: null,
    headerString: "",
    caseData: {},
  });

  const handleClick = (caseData) => {
    setModalData({
      ...modalData,
      show: true,
      caseTypeId: caseData?.case_type_id,
      headerString: `Text added to each task: Follow up on this ${caseData?.case_type?.name} case.`,
      caseData: caseData,
    });
  };

  return (
    <div className="bg-primary-2 h-100">
      <div className="bg-primary-5 height-25">
        {openCases ? (
          <h4 className="client-contact-title bg-primary-5 height-25 text-center d-flex justify-content-center align-items-center h-100">
            Attached to {openCases?.total} Open Cases
          </h4>
        ) : null}
      </div>

      {openCases?.data?.map((caseData, index) => {
        const colorClasses = [
          "fill-blueberry",
          "fill-violet",
          "fill-sky-blue",
          "fill-vivid-cerulean",
        ];
        const _colorClass = colorClasses[index % colorClasses.length];

        return (
          <div
            style={{
              background: index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
            }}
            onClick={() => handleClick(caseData)}
            className="open-case-hover height-21 d-flex align-itemsc-center justify-content-between"
          >
            <div
              className="d-flex align-items-center"
              style={{
                gap: "10px",
              }}
            >
              <span
                className="case-type-width d-flex align-items-center p-l-5"
                style={{
                  fontWeight: "600",
                }}
              >
                {caseData?.case_type?.casetype_icon && (
                  <img src={caseData?.case_type?.casetype_icon} className="m-r-5 ic-15" />
                )}
                {caseData?.case_type?.name} Cases:
              </span>
              <span
                className="count-width-home d-flex align-items-center justify-content-end text-end"
                style={{
                  fontWeight: "600",
                }}
              >
                {caseData?.count}
              </span>
            </div>
            <span
              className="p-r-5"
              style={{
                fontWeight: "600",
                width: "max-content",
              }}
            >
              {caseData?.percent}%{" "}
            </span>
            {/* <div data-percentage="35" className="progress-container">
              <span className="progress-bar-chart__label">{caseData?.percent}% </span>
              <svg
                className="progress-bar-chart"
                viewBox="0 0 100 8"
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect className="progress-bar-chart__background" width="100" height="8" />
                <rect
                  className={`progress-bar-chart__bar ${colorClass}`}
                  width={caseData?.percent}
                  height="8"
                  style={{
                    display: "inline-block",
                    width: `${caseData?.percent}%`,
                  }}
                />
              </svg>
            </div> */}
          </div>
        );
      })}

      <TaskSortedCases
        show={modalData?.show}
        handleClose={() => {
          setModalData({
            ...modalData,
            show: false,
          });
        }}
        headerString={modalData?.headerString}
        caseTypeId={modalData?.caseTypeId}
        caseData={modalData?.caseData}
      />
    </div>
  );
};
export default OpenCases;
